export default __webpack_public_path__ + "static/media/section6Img.a061e823.jpg";